import React, { Component } from "react";

// @material-ui/icons
import Storage from "@material-ui/icons/Storage";
import AttachMoney from "@material-ui/icons/AttachMoney";
import ConfirmationNumber from "@material-ui/icons/ConfirmationNumber";
import Receipt from "@material-ui/icons/Receipt";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import LockerReport from "components/LockerReport";
import SellReport from "components/SellReport";
import RpsReport from 'components/RpsReport';
import TicketReport from 'components/TicketReport';

class Relatorios extends Component {

  render() {
    let lockerId = localStorage.getItem('lockerId');
    return (
      <CustomTabs
        title="Relatórios:"
        headerColor="primary"
        tabs={[
          {
            tabName: "Posições Ocupadas",
            tabIcon: Storage,
            tabContent: (
              <LockerReport lockerId={lockerId} />

            )
          },
          {
            tabName: "Relatório de Caixa: Resumo do dia",
            tabIcon: AttachMoney,
            tabContent: (
              <SellReport lockerId={lockerId} />
            )
          },
          {
            tabName: "RPS Emitidos",
            tabIcon: ConfirmationNumber,
            tabContent: (
              <RpsReport />
            )
          },
          {
            tabName: "Tickets Emitidos",
            tabIcon: Receipt,
            tabContent: (
              <TicketReport />
            )
          }
        ]}
      />

    )
  }
}

export default Relatorios;